import HomePage from './home';

export const pages = {
  HomePage
};

export default pages;